<div class="p-2 mb-2 border-bottom header-shadow header bg-white mobile-header"
  [ngClass]="{ 'custom-background': isCustomBackground }">
  <div class="mobile-header-bar">
    <button
      type="button"
      class="mobile-menu-button"
      aria-label="Open navigation menu"
      [attr.aria-expanded]="isExpanded"
      (click)="toggleCustomDropdown()"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>

    <div class="brand">
      <a href="index.html" class="logo">
        <img [src]="themeService.isDark ? './assets/Menu sections/GAVAN_PASS_LOGO_DARK.svg' : './assets/Menu sections/GAVAN_PASS_LOGO.svg'" />
      </a>
    </div>

    <div class="mobile-header-actions">
      <span [hidden]="!auth.isApprover()" class="mobile-balance"
        [ngClass]="{'header_title': !isProfilePage, 'header_title_gradient': isProfilePage}"
        [title]="'Balance in ' + displayCurrency + ' · settled in KES'">{{ displayCurrency }} {{
        convertedBalance | number : "2.0-1" }}</span>
      <button class="theme-toggle-btn" (click)="themeService.toggle()"
        [attr.aria-label]="themeService.isDark ? 'Switch to light mode' : 'Switch to dark mode'"
        [title]="themeService.isDark ? 'Light mode' : 'Dark mode'">
        <!-- Moon — shown in light mode, click to go dark -->
        <svg *ngIf="!themeService.isDark" width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M21 12.79A9 9 0 1111.21 3a7 7 0 009.79 9.79z"
            stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <!-- Sun — shown in dark mode, click to go light -->
        <svg *ngIf="themeService.isDark" width="18" height="18" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="1.8"/>
          <path d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
            stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
      </button>
      <img class="mobile-avatar" src="./assets/Menu sections/icons/Rectangle 1058.png" alt="" />
    </div>
  </div>

  <div class="drawer-backdrop" [class.open]="isExpanded" (click)="closeDrawer()"></div>

  <aside class="mobile-drawer" [class.open]="isExpanded" aria-label="Mobile navigation">
    <div class="drawer-header">
      <button type="button" class="drawer-close-icon" aria-label="Close navigation menu" (click)="closeDrawer()">
        <span></span>
        <span></span>
      </button>
      <a href="index.html" class="drawer-logo">
        <img [src]="themeService.isDark ? './assets/Menu sections/GAVAN_PASS_LOGO_DARK.svg' : './assets/Menu sections/GAVAN_PASS_LOGO.svg'" />
      </a>
    </div>

    <nav #contentWrapper class="drawer-content">
      <ul class="drawer-list">
        <li *ngFor="let val of menuList" class="drawer-item" [class.has-submenu]="val.submenu">
          <button
            type="button"
            [ngClass]="val.menu_opened ? 'colored-menu' : 'non-colored'"
            class="drawer-link"
            [class.menu-item-off]="val.disabled"
            [title]="val.disabled ? 'Module disabled for this organisation' : null"
            [attr.aria-disabled]="val.disabled ? true : null"
            (click)="toggleMenu(val)"
          >
            <img *ngIf="val.menu_opened; else closedImage" class="sidebar-icon"
              src="./assets/Menu sections/{{ val.openedImage }}" />
            <ng-template #closedImage>
              <img class="sidebar-icon" src="./assets/Menu sections/{{ val.icon }}" />
            </ng-template>
            <span class="sidebar-menu" [ngClass]="val.menu_opened ? 'open-menu' : 'close-menu' ">
              {{ val.title }}
            </span>
            <span *ngIf="val.submenu" class="submenu-chevron travel_management_icons"></span>
            <span *ngIf="val.disabled" class="off-badge">OFF</span>
          </button>

          <ul *ngIf="val.showSubmenu" class="submenu-list">
            <li *ngFor="let subItem of val.submenu">
              <button
                type="button"
                class="drawer-link submenu-link"
                [class.menu-item-off]="subItem.disabled"
                [title]="subItem.disabled ? 'Module disabled for this organisation' : null"
                [ngClass]="subItem.menu_opened ? 'subItem-colored' : 'subItem-black'"
                (click)="navigateSubMenu(subItem)"
              >
                <img *ngIf="subItem.menu_opened; else subClosedImage" class="sidebar-icon"
                  src="./assets/Menu sections/{{ subItem.openedImage }}" />
                <ng-template #subClosedImage>
                  <img class="sidebar-icon" src="./assets/Menu sections/{{ subItem.icon }}" />
                </ng-template>
                <span>{{ subItem.title }}</span>
                <span *ngIf="subItem.disabled" class="off-badge">OFF</span>
              </button>
            </li>
          </ul>
        </li>
      </ul>

      <div class="bottom-menu">
        <div class="accordion">
          <details>
            <summary>Customer support</summary>
            <div class="content">
              <a href="tel:+254767902" class="support-row">
                <img class="sidebar-icon" src="./assets/Menu sections/phoneIcon.png" />
                <span class="sidebar-menu">Call +254767902</span>
              </a>
              <a href="mailto:corporate@buupass.com" class="support-row">
                <img class="sidebar-icon" src="./assets/Menu sections/email.png" />
                <span class="sidebar-menu">corporate&#64;buupass.com</span>
              </a>
            </div>
          </details>
        </div>

        <button type="button" class="drawer-link logout-link" (click)="auth.logout()">
          <span class="logout-icon-placeholder" aria-hidden="true"></span>
          <span class="sidebar-menu">Logout</span>
        </button>
      </div>
    </nav>
  </aside>
</div>
